import lightTheme from '../components/style/lightTheme';

const MuiBreadcrumbs = {
  styleOverrides: {
    root: {
      color: lightTheme.textPrimary,
      cursor: 'pointer',
      '&.MuiBreadcrumbs-li': {
        color: lightTheme.textPrimary,
      },
    },
  },
};

export default MuiBreadcrumbs;
